// // // // import React, { useState, useEffect } from 'react';
// // // // import { Link, useLocation as useRouterLocation, useNavigate } from 'react-router-dom';
// // // // import { Button } from './ui/button';
// // // // import { Input } from './ui/input';
// // // // import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
// // // // import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from './ui/dropdown-menu';
// // // // import { Search, Menu, ShoppingCart, MapPin, ChevronDown, User, LogOut, Package, Heart } from 'lucide-react';
// // // // import { useCart } from '../context/CartContext';
// // // // import { useLocation } from '../context/LocationContext';
// // // // import { useAuth } from '../context/AuthContext';
// // // // import apiService from '../services/api';
// // // // import NotificationBell from './NotificationBell';

// // // // const Header = () => {
// // // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // // //   const [categories, setCategories] = useState([]);
// // // //   const location = useRouterLocation();
// // // //   const navigate = useNavigate();
// // // //   const { getCartItemsCount } = useCart();
// // // //   const { selectedLocation, locations, changeLocation } = useLocation();
// // // //   const { user, isAuthenticated, logout } = useAuth();

// // // //   // Load categories for menu
// // // //   useEffect(() => {
// // // //     loadCategories();
// // // //   }, []);

// // // //   const loadCategories = async () => {
// // // //     try {
// // // //       const data = await apiService.categories.getAll();
// // // //       setCategories(data.slice(0, 5)); // Show top 5 categories in menu
// // // //     } catch (error) {
// // // //       console.error('Error loading categories:', error);
// // // //     }
// // // //   };

// // // //   const isActive = (path) => location.pathname === path;

// // // //   return (
// // // //     <header className="bg-white shadow-sm border-b">
// // // //       {/* Top bar */}
// // // //       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600 text-center">
// // // //         <div className="flex items-center justify-between max-w-7xl mx-auto">
// // // //           <div className="flex items-center gap-4">
// // // //             <span>Call or WhatsApp: +91 8121034991</span>
// // // //           </div>
// // // //           <div className="flex items-center gap-2">
// // // //             <MapPin className="w-4 h-4" />
// // // //             {selectedLocation && (
// // // //               <DropdownMenu>
// // // //                 <DropdownMenuTrigger className="flex items-center gap-1 hover:text-gray-900">
// // // //                   {selectedLocation.name}
// // // //                   <ChevronDown className="w-3 h-3" />
// // // //                 </DropdownMenuTrigger>
// // // //                 <DropdownMenuContent>
// // // //                   {locations.map((loc) => (
// // // //                     <DropdownMenuItem
// // // //                       key={loc.id}
// // // //                       onClick={() => changeLocation(loc)}
// // // //                       className={selectedLocation.id === loc.id ? 'bg-pink-50' : ''}
// // // //                     >
// // // //                       {loc.name}, {loc.city}
// // // //                     </DropdownMenuItem>
// // // //                   ))}
// // // //                 </DropdownMenuContent>
// // // //               </DropdownMenu>
// // // //             )}
// // // //           </div>
// // // //           <div>
// // // //             <span>Mail Us: hello@bakelore.com</span>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Main header */}
// // // //       <div className="px-4 py-4">
// // // //         <div className="max-w-7xl mx-auto flex items-center justify-between">
// // // //           {/* Logo */}
// // // //           <Link to="/" className="flex items-center">
// // // //             <div className="text-2xl font-bold text-pink-400">
// // // //               Bakelore
// // // //             </div>
// // // //           </Link>

// // // //           {/* Desktop Navigation */}
// // // //           <nav className="hidden md:flex items-center space-x-8">
// // // //             <Link
// // // //               to="/"
// // // //               className={`text-gray-700 hover:text-pink-400 transition-colors ${
// // // //                 isActive('/') ? 'text-pink-400 font-medium' : ''
// // // //               }`}
// // // //             >
// // // //               HOME
// // // //             </Link>
// // // //             <Link
// // // //               to="/about"
// // // //               className={`text-gray-700 hover:text-pink-400 transition-colors ${
// // // //                 isActive('/about') ? 'text-pink-400 font-medium' : ''
// // // //               }`}
// // // //             >
// // // //               ABOUT US
// // // //             </Link>
// // // //             <DropdownMenu>
// // // //               <DropdownMenuTrigger className="flex items-center gap-1 text-gray-700 hover:text-pink-400 transition-colors">
// // // //                 ORDER NOW
// // // //                 <ChevronDown className="w-4 h-4" />
// // // //               </DropdownMenuTrigger>
// // // //               <DropdownMenuContent>
// // // //                 <DropdownMenuItem asChild>
// // // //                   <Link to="/products">All Products</Link>
// // // //                 </DropdownMenuItem>
// // // //                 {categories.map((category) => (
// // // //                   <DropdownMenuItem key={category.id} asChild>
// // // //                     <Link to={`/products?categoryId=${category.id}`}>
// // // //                       {category.name}
// // // //                     </Link>
// // // //                   </DropdownMenuItem>
// // // //                 ))}
// // // //               </DropdownMenuContent>
// // // //             </DropdownMenu>
// // // //             <Link
// // // //               to="/contact"
// // // //               className={`text-gray-700 hover:text-pink-400 transition-colors ${
// // // //                 isActive('/contact') ? 'text-pink-400 font-medium' : ''
// // // //               }`}
// // // //             >
// // // //               CONTACT US
// // // //             </Link>
// // // //             <Link
// // // //               to="/blog"
// // // //               className={`text-gray-700 hover:text-pink-400 transition-colors ${
// // // //                 isActive('/blog') ? 'text-pink-400 font-medium' : ''
// // // //               }`}
// // // //             >
// // // //               BLOG
// // // //             </Link>
// // // //           </nav>

// // // //           {/* Search, Cart, and User Menu */}
// // // //           <div className="flex items-center space-x-4">
// // // //             <div className="hidden md:flex items-center space-x-2">
// // // //               <div className="relative">
// // // //                 <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
// // // //                 <Input
// // // //                   placeholder="Search products..."
// // // //                   className="pl-10 w-64"
// // // //                 />
// // // //               </div>
// // // //             </div>

// // // //             {/* Notification Bell */}
// // // //             <NotificationBell />

// // // //             <Link to="/cart">
// // // //               <Button variant="outline" size="sm" className="flex items-center gap-2 text-pink-400 border-pink-400 hover:bg-pink-50">
// // // //                 <ShoppingCart className="w-4 h-4" />
// // // //                 <span className="hidden sm:inline">MY CART</span>
// // // //                 <span className="bg-pink-400 text-white rounded-full px-2 py-0.5 text-xs">{getCartItemsCount()}</span>
// // // //               </Button>
// // // //             </Link>

// // // //             {/* User Profile Menu */}
// // // //             {isAuthenticated ? (
// // // //               <DropdownMenu>
// // // //                 <DropdownMenuTrigger asChild>
// // // //                   <Button variant="outline" size="sm" className="flex items-center gap-2 text-gray-700 border-gray-300 hover:bg-gray-50">
// // // //                     <User className="w-4 h-4" />
// // // //                     <span className="hidden sm:inline">{user?.email?.split('@')[0] || 'Account'}</span>
// // // //                     <ChevronDown className="w-3 h-3" />
// // // //                   </Button>
// // // //                 </DropdownMenuTrigger>
// // // //                 <DropdownMenuContent align="end" className="w-48">
// // // //                   <DropdownMenuItem asChild>
// // // //                     <Link to="/dashboard" className="flex items-center gap-2">
// // // //                       <User className="w-4 h-4" />
// // // //                       Dashboard
// // // //                     </Link>
// // // //                   </DropdownMenuItem>
// // // //                   <DropdownMenuItem asChild>
// // // //                     <Link to="/dashboard" className="flex items-center gap-2">
// // // //                       <Package className="w-4 h-4" />
// // // //                       My Orders
// // // //                     </Link>
// // // //                   </DropdownMenuItem>
// // // //                   <DropdownMenuItem asChild>
// // // //                     <Link to="/wishlist" className="flex items-center gap-2">
// // // //                       <Heart className="w-4 h-4" />
// // // //                       Wishlist
// // // //                     </Link>
// // // //                   </DropdownMenuItem>
// // // //                   <DropdownMenuSeparator />
// // // //                   <DropdownMenuItem onClick={logout} className="flex items-center gap-2 text-red-600">
// // // //                     <LogOut className="w-4 h-4" />
// // // //                     Logout
// // // //                   </DropdownMenuItem>
// // // //                 </DropdownMenuContent>
// // // //               </DropdownMenu>
// // // //             ) : (
// // // //               <Button
// // // //                 size="sm"
// // // //                 className="bg-pink-400 hover:bg-pink-500 text-white"
// // // //                 onClick={() => navigate('/auth')}
// // // //               >
// // // //                 <User className="w-4 h-4 mr-2" />
// // // //                 Login
// // // //               </Button>
// // // //             )}

// // // //             {/* Mobile menu trigger */}
// // // //             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
// // // //               <SheetTrigger asChild>
// // // //                 <Button variant="ghost" size="sm" className="md:hidden">
// // // //                   <Menu className="w-5 h-5" />
// // // //                 </Button>
// // // //               </SheetTrigger>
// // // //               <SheetContent side="right" className="w-80">
// // // //                 <nav className="flex flex-col space-y-4 mt-8">
// // // //                   <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-lg font-medium text-gray-700 hover:text-pink-400">
// // // //                     HOME
// // // //                   </Link>
// // // //                   <Link to="/about" onClick={() => setIsMenuOpen(false)} className="text-lg font-medium text-gray-700 hover:text-pink-400">
// // // //                     ABOUT US
// // // //                   </Link>
// // // //                   <Link to="/products" onClick={() => setIsMenuOpen(false)} className="text-lg font-medium text-gray-700 hover:text-pink-400">
// // // //                     ORDER NOW
// // // //                   </Link>
// // // //                   <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="text-lg font-medium text-gray-700 hover:text-pink-400">
// // // //                     CONTACT US
// // // //                   </Link>
// // // //                   <Link to="/blog" onClick={() => setIsMenuOpen(false)} className="text-lg font-medium text-gray-700 hover:text-pink-400">
// // // //                     BLOG
// // // //                   </Link>
// // // //                   <div className="pt-4">
// // // //                     <Input placeholder="Search products..." />
// // // //                   </div>
// // // //                 </nav>
// // // //               </SheetContent>
// // // //             </Sheet>
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //     </header>
// // // //   );
// // // // };

// // // // export default Header;

// // // import React, { useState, useEffect } from 'react';
// // // import { Link, useLocation as useRouterLocation, useNavigate } from 'react-router-dom';
// // // import { Button } from './ui/button';
// // // import { Input } from './ui/input';
// // // import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
// // // import {
// // //   DropdownMenu,
// // //   DropdownMenuContent,
// // //   DropdownMenuItem,
// // //   DropdownMenuTrigger,
// // // } from './ui/dropdown-menu';
// // // import {
// // //   Search,
// // //   Menu,
// // //   MapPin,
// // //   ChevronDown,
// // // } from 'lucide-react';
// // // import { useLocation } from '../context/LocationContext';
// // // import apiService from '../services/api';
// // // import NotificationBell from './NotificationBell';

// // // const Header = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [categories, setCategories] = useState([]);
// // //   const [searchTerm, setSearchTerm] = useState('');
// // //   const location = useRouterLocation();
// // //   const navigate = useNavigate();
// // //   const { selectedLocation, locations, changeLocation } = useLocation();

// // //   useEffect(() => {
// // //     loadCategories();
// // //   }, []);

// // //   const loadCategories = async () => {
// // //     try {
// // //       const data = await apiService.categories.getAll();
// // //       setCategories(data.slice(0, 5));
// // //     } catch (error) {
// // //       console.error('Error loading categories:', error);
// // //     }
// // //   };

// // //   const isActive = (path) => location.pathname === path;

// // //   // ✅ Handle search submit
// // //   const handleSearch = (e) => {
// // //     e.preventDefault();
// // //     if (searchTerm.trim()) {
// // //       navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
// // //       setSearchTerm('');
// // //     }
// // //   };

// // //   return (
// // //     <header className="bg-white shadow-sm border-b">
// // //       {/* Top bar */}
// // //       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600 text-center">
// // //         <div className="flex items-center justify-between max-w-7xl mx-auto">
// // //           <div className="flex items-center gap-4">
// // //             <span>Call or WhatsApp: +91 8121034991</span>
// // //           </div>
// // //           <div className="flex items-center gap-2">
// // //             <MapPin className="w-4 h-4" />
// // //             {selectedLocation && (
// // //               <DropdownMenu>
// // //                 <DropdownMenuTrigger className="flex items-center gap-1 hover:text-gray-900">
// // //                   {selectedLocation.name}
// // //                   <ChevronDown className="w-3 h-3" />
// // //                 </DropdownMenuTrigger>
// // //                 <DropdownMenuContent>
// // //                   {locations.map((loc) => (
// // //                     <DropdownMenuItem
// // //                       key={loc.id}
// // //                       onClick={() => changeLocation(loc)}
// // //                       className={selectedLocation.id === loc.id ? 'bg-[#F3E5E4]' : ''}
// // //                     >
// // //                       {loc.name}, {loc.city}
// // //                     </DropdownMenuItem>
// // //                   ))}
// // //                 </DropdownMenuContent>
// // //               </DropdownMenu>
// // //             )}
// // //           </div>
// // //           <div>
// // //             <span>Mail Us: hello@bakelore.com</span>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Main header */}
// // //       <div className="px-4 py-4">
// // //         <div className="max-w-7xl mx-auto flex items-center justify-between">
// // //           {/* Logo */}
// // //           <Link to="/" className="flex items-center">
// // //             <div className="text-2xl font-bold" style={{ color: '#C08B89' }}>
// // //               Bakelore
// // //             </div>
// // //           </Link>

// // //           {/* Desktop Navigation */}
// // //           <nav className="hidden md:flex items-center space-x-8">
// // //             {[
// // //               { path: '/', label: 'HOME' },
// // //               { path: '/about', label: 'ABOUT US' },
// // //               { path: '/contact', label: 'CONTACT US' },
// // //               { path: '/blog', label: 'BLOG' },
// // //             ].map((link) => (
// // //               <Link
// // //                 key={link.path}
// // //                 to={link.path}
// // //                 className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
// // //                   isActive(link.path) ? 'font-medium' : ''
// // //                 }`}
// // //                 style={isActive(link.path) ? { color: '#C08B89' } : {}}
// // //               >
// // //                 {link.label}
// // //               </Link>
// // //             ))}

// // //             {/* Order Now Dropdown */}
// // //             <DropdownMenu>
// // //               <DropdownMenuTrigger className="flex items-center gap-1 text-gray-700 hover:text-[#C08B89] transition-colors">
// // //                 ORDER NOW
// // //                 <ChevronDown className="w-4 h-4" />
// // //               </DropdownMenuTrigger>
// // //               <DropdownMenuContent>
// // //                 <DropdownMenuItem asChild>
// // //                   <Link to="/products">All Products</Link>
// // //                 </DropdownMenuItem>
// // //                 {categories.map((category) => (
// // //                   <DropdownMenuItem key={category.id} asChild>
// // //                     <Link to={`/products?categoryId=${category.id}`}>
// // //                       {category.name}
// // //                     </Link>
// // //                   </DropdownMenuItem>
// // //                 ))}
// // //               </DropdownMenuContent>
// // //             </DropdownMenu>
// // //           </nav>

// // //           {/* Right Side */}
// // //           <div className="flex items-center space-x-4">
// // //             {/* ✅ Search box now functional */}
// // //             <form onSubmit={handleSearch} className="hidden md:flex items-center space-x-2">
// // //               <div className="relative">
// // //                 <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
// // //                 <Input
// // //                   placeholder="Search products..."
// // //                   className="pl-10 w-64"
// // //                   value={searchTerm}
// // //                   onChange={(e) => setSearchTerm(e.target.value)}
// // //                 />
// // //               </div>
// // //             </form>

// // //             {/* Notifications */}
// // //             <NotificationBell />

// // //             {/* Mobile Menu */}
// // //             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
// // //               <SheetTrigger asChild>
// // //                 <Button variant="ghost" size="sm" className="md:hidden">
// // //                   <Menu className="w-5 h-5" />
// // //                 </Button>
// // //               </SheetTrigger>
// // //               <SheetContent side="right" className="w-80">
// // //                 <nav className="flex flex-col space-y-4 mt-8">
// // //                   {['HOME', 'ABOUT US', 'ORDER NOW', 'CONTACT US', 'BLOG'].map(
// // //                     (label, i) => (
// // //                       <Link
// // //                         key={i}
// // //                         to={`/${label.toLowerCase().replace(' ', '')}`}
// // //                         onClick={() => setIsMenuOpen(false)}
// // //                         className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
// // //                       >
// // //                         {label}
// // //                       </Link>
// // //                     )
// // //                   )}
// // //                   <div className="pt-4">
// // //                     <form onSubmit={handleSearch}>
// // //                       <Input
// // //                         placeholder="Search products..."
// // //                         value={searchTerm}
// // //                         onChange={(e) => setSearchTerm(e.target.value)}
// // //                       />
// // //                     </form>
// // //                   </div>
// // //                 </nav>
// // //               </SheetContent>
// // //             </Sheet>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </header>
// // //   );
// // // };

// // // export default Header;

// // // import React, { useState, useEffect } from "react";
// // // import { Link, useLocation as useRouterLocation, useNavigate } from "react-router-dom";
// // // import { Button } from "./ui/button";
// // // import { Input } from "./ui/input";
// // // import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
// // // import {
// // //   DropdownMenu,
// // //   DropdownMenuContent,
// // //   DropdownMenuItem,
// // //   DropdownMenuTrigger,
// // // } from "./ui/dropdown-menu";
// // // import { Search, Menu, MapPin, ChevronDown } from "lucide-react";
// // // import { useLocation } from "../context/LocationContext";
// // // import apiService from "../services/api";
// // // import NotificationBell from "./NotificationBell";

// // // const Header = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [categories, setCategories] = useState([]);
// // //   const [searchTerm, setSearchTerm] = useState("");
// // //   const location = useRouterLocation();
// // //   const navigate = useNavigate();
// // //   const { selectedLocation, locations, changeLocation } = useLocation();

// // //   useEffect(() => {
// // //     loadCategories();
// // //   }, []);

// // //   const loadCategories = async () => {
// // //     try {
// // //       const data = await apiService.categories.getAll();
// // //       setCategories(data.slice(0, 5));
// // //     } catch (error) {
// // //       console.error("Error loading categories:", error);
// // //     }
// // //   };

// // //   const isActive = (path) => location.pathname === path;

// // //   const handleSearch = (e) => {
// // //     e.preventDefault();
// // //     if (searchTerm.trim()) {
// // //       navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
// // //       setSearchTerm("");
// // //     }
// // //   };

// // //   return (
// // //     <header className="bg-white shadow-sm border-b w-full">
// // //       {/* ✅ Top Bar */}
// // //       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600">
// // //         <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
// // //           <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2">
// // //             <span>📞 Call / WhatsApp: +91 8121034991</span>
// // //           </div>

// // //           {/* Location Dropdown */}
// // //           <div className="flex items-center justify-center sm:justify-start gap-1">
// // //             <MapPin className="w-4 h-4" />
// // //             {selectedLocation && (
// // //               <DropdownMenu>
// // //                 <DropdownMenuTrigger className="flex items-center gap-1 hover:text-gray-900">
// // //                   {selectedLocation.name}
// // //                   <ChevronDown className="w-3 h-3" />
// // //                 </DropdownMenuTrigger>
// // //                 <DropdownMenuContent align="end">
// // //                   {locations.map((loc) => (
// // //                     <DropdownMenuItem
// // //                       key={loc.id}
// // //                       onClick={() => changeLocation(loc)}
// // //                       className={selectedLocation.id === loc.id ? "bg-[#F3E5E4]" : ""}
// // //                     >
// // //                       {loc.name}, {loc.city}
// // //                     </DropdownMenuItem>
// // //                   ))}
// // //                 </DropdownMenuContent>
// // //               </DropdownMenu>
// // //             )}
// // //           </div>

// // //           <div className="flex justify-center sm:justify-end">
// // //             <span>📧 hello@bakelore.com</span>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* ✅ Main Header */}
// // //       <div className="px-4 py-3 sm:py-4">
// // //         <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">
// // //           {/* Logo */}
// // //           <Link to="/" className="flex items-center">
// // //             <h1 className="text-2xl font-bold text-[#C08B89]">Bakelore</h1>
// // //           </Link>

// // //           {/* Desktop Nav */}
// // //           <nav className="hidden md:flex items-center space-x-8">
// // //             {[
// // //               { path: "/", label: "HOME" },
// // //               { path: "/about", label: "ABOUT US" },
// // //               { path: "/contact", label: "CONTACT US" },
// // //               { path: "/blog", label: "BLOG" },
// // //             ].map((link) => (
// // //               <Link
// // //                 key={link.path}
// // //                 to={link.path}
// // //                 className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
// // //                   isActive(link.path) ? "font-semibold text-[#C08B89]" : ""
// // //                 }`}
// // //               >
// // //                 {link.label}
// // //               </Link>
// // //             ))}

// // //             {/* Dropdown */}
// // //             <DropdownMenu>
// // //               <DropdownMenuTrigger className="flex items-center gap-1 text-gray-700 hover:text-[#C08B89] transition-colors">
// // //                 ORDER NOW
// // //                 <ChevronDown className="w-4 h-4" />
// // //               </DropdownMenuTrigger>
// // //               <DropdownMenuContent align="end">
// // //                 <DropdownMenuItem asChild>
// // //                   <Link to="/products">All Products</Link>
// // //                 </DropdownMenuItem>
// // //                 {categories.map((cat) => (
// // //                   <DropdownMenuItem key={cat.id} asChild>
// // //                     <Link to={`/products?categoryId=${cat.id}`}>{cat.name}</Link>
// // //                   </DropdownMenuItem>
// // //                 ))}
// // //               </DropdownMenuContent>
// // //             </DropdownMenu>
// // //           </nav>

// // //           {/* ✅ Right Section */}
// // //           <div className="flex items-center space-x-3 ml-auto md:ml-0">
// // //             {/* Search Box (hidden on mobile) */}
// // //             <form
// // //               onSubmit={handleSearch}
// // //               className="hidden md:flex items-center space-x-2"
// // //             >
// // //               <div className="relative">
// // //                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
// // //                 <Input
// // //                   placeholder="Search products..."
// // //                   className="pl-10 w-56 lg:w-64"
// // //                   value={searchTerm}
// // //                   onChange={(e) => setSearchTerm(e.target.value)}
// // //                 />
// // //               </div>
// // //             </form>

// // //             {/* Notification */}
// // //             <NotificationBell />

// // //             {/* Mobile Menu */}
// // //             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
// // //               <SheetTrigger asChild>
// // //                 <Button variant="ghost" size="sm" className="md:hidden">
// // //                   <Menu className="w-6 h-6" />
// // //                 </Button>
// // //               </SheetTrigger>
// // //               <SheetContent side="right" className="w-72 sm:w-80">
// // //                 <div className="flex flex-col space-y-5 mt-8">
// // //                   {[
// // //                     { path: "/", label: "HOME" },
// // //                     { path: "/about", label: "ABOUT US" },
// // //                     { path: "/products", label: "ORDER NOW" },
// // //                     { path: "/contact", label: "CONTACT US" },
// // //                     { path: "/blog", label: "BLOG" },
// // //                   ].map((link) => (
// // //                     <Link
// // //                       key={link.path}
// // //                       to={link.path}
// // //                       onClick={() => setIsMenuOpen(false)}
// // //                       className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
// // //                     >
// // //                       {link.label}
// // //                     </Link>
// // //                   ))}

// // //                   {/* Mobile Search */}
// // //                   <form onSubmit={handleSearch}>
// // //                     <Input
// // //                       placeholder="Search products..."
// // //                       className="mt-3"
// // //                       value={searchTerm}
// // //                       onChange={(e) => setSearchTerm(e.target.value)}
// // //                     />
// // //                   </form>
// // //                 </div>
// // //               </SheetContent>
// // //             </Sheet>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </header>
// // //   );
// // // };

// // // export default Header;

// // // import React, { useState, useEffect } from "react";
// // // import { Link, useLocation as useRouterLocation, useNavigate } from "react-router-dom";
// // // import { Button } from "./ui/button";
// // // import { Input } from "./ui/input";
// // // import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
// // // import {
// // //   DropdownMenu,
// // //   DropdownMenuContent,
// // //   DropdownMenuItem,
// // //   DropdownMenuTrigger,
// // // } from "./ui/dropdown-menu";
// // // import { Search, Menu, MapPin, ChevronDown } from "lucide-react";
// // // import { useLocation } from "../context/LocationContext";
// // // import apiService from "../services/api";
// // // import NotificationBell from "./NotificationBell";

// // // const Header = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [categories, setCategories] = useState([]);
// // //   const [searchTerm, setSearchTerm] = useState("");
// // //   const location = useRouterLocation();
// // //   const navigate = useNavigate();
// // //   const { selectedLocation, locations, changeLocation } = useLocation();

// // //   useEffect(() => {
// // //     loadCategories();
// // //   }, []);

// // //   const loadCategories = async () => {
// // //     try {
// // //       const data = await apiService.categories.getAll();
// // //       setCategories(data.slice(0, 5));
// // //     } catch (error) {
// // //       console.error("Error loading categories:", error);
// // //     }
// // //   };

// // //   const isActive = (path) => location.pathname === path;

// // //   const handleSearch = (e) => {
// // //     e.preventDefault();
// // //     if (searchTerm.trim()) {
// // //       navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
// // //       setSearchTerm("");
// // //     }
// // //   };

// // //   return (
// // //     <header className="bg-white shadow-sm border-b w-full">
// // //       {/* ✅ Top Bar */}
// // //       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600">
// // //         <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
// // //           <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2">
// // //             <span>📞 Call / WhatsApp: +91 8121034991</span>
// // //           </div>

// // //           {/* Location Dropdown */}
// // //           <div className="flex items-center justify-center sm:justify-start gap-1">
// // //             <MapPin className="w-4 h-4" />
// // //             {selectedLocation && (
// // //               <DropdownMenu>
// // //                 <DropdownMenuTrigger className="flex items-center gap-1 hover:text-gray-900">
// // //                   {selectedLocation.name}
// // //                   <ChevronDown className="w-3 h-3" />
// // //                 </DropdownMenuTrigger>
// // //                 <DropdownMenuContent align="end">
// // //                   {locations.map((loc) => (
// // //                     <DropdownMenuItem
// // //                       key={loc.id}
// // //                       onClick={() => changeLocation(loc)}
// // //                       className={selectedLocation.id === loc.id ? "bg-[#F3E5E4]" : ""}
// // //                     >
// // //                       {loc.name}, {loc.city}
// // //                     </DropdownMenuItem>
// // //                   ))}
// // //                 </DropdownMenuContent>
// // //               </DropdownMenu>
// // //             )}
// // //           </div>

// // //           <div className="flex justify-center sm:justify-end">
// // //             <span>📧 hello@bakelore.com</span>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* ✅ Main Header */}
// // //       <div className="px-4 py-3 sm:py-4">
// // //         <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">
// // //           {/* ✅ Image Logo */}
// // //           <Link to="/" className="flex items-center">
// // //             <img
// // //               src="http://bakelore.com/images/bakelore-logo"
// // //               alt="Bakelore Logo"
// // //               className="h-10 w-auto sm:h-12"
// // //             />
// // //           </Link>

// // //           {/* Desktop Nav */}
// // //           <nav className="hidden md:flex items-center space-x-8">
// // //             {[
// // //               { path: "/", label: "HOME" },
// // //               { path: "/about", label: "ABOUT US" },
// // //               { path: "/contact", label: "CONTACT US" },
// // //               { path: "/blog", label: "BLOG" },
// // //             ].map((link) => (
// // //               <Link
// // //                 key={link.path}
// // //                 to={link.path}
// // //                 className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
// // //                   isActive(link.path) ? "font-semibold text-[#C08B89]" : ""
// // //                 }`}
// // //               >
// // //                 {link.label}
// // //               </Link>
// // //             ))}

// // //             {/* Dropdown */}
// // //             <DropdownMenu>
// // //               <DropdownMenuTrigger className="flex items-center gap-1 text-gray-700 hover:text-[#C08B89] transition-colors">
// // //                 ORDER NOW
// // //                 <ChevronDown className="w-4 h-4" />
// // //               </DropdownMenuTrigger>
// // //               <DropdownMenuContent align="end">
// // //                 <DropdownMenuItem asChild>
// // //                   <Link to="/products">All Products</Link>
// // //                 </DropdownMenuItem>
// // //                 {categories.map((cat) => (
// // //                   <DropdownMenuItem key={cat.id} asChild>
// // //                     <Link to={`/products?categoryId=${cat.id}`}>{cat.name}</Link>
// // //                   </DropdownMenuItem>
// // //                 ))}
// // //               </DropdownMenuContent>
// // //             </DropdownMenu>
// // //           </nav>

// // //           {/* ✅ Right Section */}
// // //           <div className="flex items-center space-x-3 ml-auto md:ml-0">
// // //             {/* Search Box (hidden on mobile) */}
// // //             <form
// // //               onSubmit={handleSearch}
// // //               className="hidden md:flex items-center space-x-2"
// // //             >
// // //               <div className="relative">
// // //                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
// // //                 <Input
// // //                   placeholder="Search products..."
// // //                   className="pl-10 w-56 lg:w-64"
// // //                   value={searchTerm}
// // //                   onChange={(e) => setSearchTerm(e.target.value)}
// // //                 />
// // //               </div>
// // //             </form>

// // //             {/* Notification */}
// // //             <NotificationBell />

// // //             {/* Mobile Menu */}
// // //             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
// // //               <SheetTrigger asChild>
// // //                 <Button variant="ghost" size="sm" className="md:hidden">
// // //                   <Menu className="w-6 h-6" />
// // //                 </Button>
// // //               </SheetTrigger>
// // //               <SheetContent side="right" className="w-72 sm:w-80">
// // //                 <div className="flex flex-col space-y-5 mt-8">
// // //                   {[
// // //                     { path: "/", label: "HOME" },
// // //                     { path: "/about", label: "ABOUT US" },
// // //                     { path: "/products", label: "ORDER NOW" },
// // //                     { path: "/contact", label: "CONTACT US" },
// // //                     { path: "/blog", label: "BLOG" },
// // //                   ].map((link) => (
// // //                     <Link
// // //                       key={link.path}
// // //                       to={link.path}
// // //                       onClick={() => setIsMenuOpen(false)}
// // //                       className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
// // //                     >
// // //                       {link.label}
// // //                     </Link>
// // //                   ))}

// // //                   {/* Mobile Search */}
// // //                   <form onSubmit={handleSearch}>
// // //                     <Input
// // //                       placeholder="Search products..."
// // //                       className="mt-3"
// // //                       value={searchTerm}
// // //                       onChange={(e) => setSearchTerm(e.target.value)}
// // //                     />
// // //                   </form>
// // //                 </div>
// // //               </SheetContent>
// // //             </Sheet>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </header>
// // //   );
// // // };

// // // export default Header;

// // // import React, { useState, useEffect } from "react";
// // // import { Link, useLocation as useRouterLocation, useNavigate } from "react-router-dom";
// // // import { Button } from "./ui/button";
// // // import { Input } from "./ui/input";
// // // import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
// // // import {
// // //   DropdownMenu,
// // //   DropdownMenuContent,
// // //   DropdownMenuItem,
// // //   DropdownMenuTrigger,
// // // } from "./ui/dropdown-menu";
// // // import { Search, Menu, MapPin, ChevronDown } from "lucide-react";
// // // import { useLocation } from "../context/LocationContext";
// // // import apiService from "../services/api";
// // // import NotificationBell from "./NotificationBell";

// // // const Header = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [categories, setCategories] = useState([]);
// // //   const [searchTerm, setSearchTerm] = useState("");
// // //   const location = useRouterLocation();
// // //   const navigate = useNavigate();
// // //   const { selectedLocation, locations, changeLocation } = useLocation();

// // //   useEffect(() => {
// // //     loadCategories();
// // //   }, []);

// // //   const loadCategories = async () => {
// // //     try {
// // //       const data = await apiService.categories.getAll();
// // //       setCategories(data.slice(0, 5));
// // //     } catch (error) {
// // //       console.error("Error loading categories:", error);
// // //     }
// // //   };

// // //   const isActive = (path) => location.pathname === path;

// // //   const handleSearch = (e) => {
// // //     e.preventDefault();
// // //     if (searchTerm.trim()) {
// // //       navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
// // //       setSearchTerm("");
// // //     }
// // //   };

// // //   return (
// // //     <header className="bg-white shadow-sm border-b w-full" style={{ fontFamily: "Manrope, sans-serif" }}>
// // //       {/* Top Bar */}
// // //       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600">
// // //         <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
// // //           <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2">
// // //             <span>📞 Call / WhatsApp: +91 8121034991</span>
// // //           </div>

// // //           {/* Location Dropdown */}
// // //           <div className="flex items-center justify-center sm:justify-start gap-1">
// // //             <MapPin className="w-4 h-4" />
// // //             {selectedLocation && (
// // //               <DropdownMenu>
// // //                 <DropdownMenuTrigger
// // //                   className="flex items-center gap-1 hover:text-gray-900"
// // //                   style={{ fontFamily: "Philosopher", serif" }}
// // //                 >
// // //                   {selectedLocation.name}
// // //                   <ChevronDown className="w-3 h-3" />
// // //                 </DropdownMenuTrigger>
// // //                 <DropdownMenuContent align="end">
// // //                   {locations.map((loc) => (
// // //                     <DropdownMenuItem
// // //                       key={loc.id}
// // //                       onClick={() => changeLocation(loc)}
// // //                       className={selectedLocation.id === loc.id ? "bg-[#F3E5E4]" : ""}
// // //                     >
// // //                       {loc.name}, {loc.city}
// // //                     </DropdownMenuItem>
// // //                   ))}
// // //                 </DropdownMenuContent>
// // //               </DropdownMenu>
// // //             )}
// // //           </div>

// // //           <div className="flex justify-center sm:justify-end">
// // //             <span>📧 hello@bakelore.com</span>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Main Header */}
// // //       <div className="px-4 py-3 sm:py-4">
// // //         <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">
// // //           {/* Logo */}
// // //           <Link to="/" className="flex items-center">
// // //             <img
// // //               src="http://bakelore.com/images/bakelore-logo"
// // //               alt="Bakelore Logo"
// // //               className="h-10 w-auto sm:h-12"
// // //             />
// // //           </Link>

// // //           {/* Desktop Nav */}
// // //           <nav className="hidden md:flex items-center space-x-8" style={{ fontFamily: "Philosopher", serif" }}>
// // //             {[
// // //               { path: "/", label: "HOME" },
// // //               { path: "/about", label: "ABOUT US" },
// // //               { path: "/contact", label: "CONTACT US" },
// // //               // { path: "/blog", label: "BLOG" },
// // //             ].map((link) => (
// // //               <Link
// // //                 key={link.path}
// // //                 to={link.path}
// // //                 className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
// // //                   isActive(link.path) ? "font-semibold text-[#C08B89]" : ""
// // //                 }`}
// // //               >
// // //                 {link.label}
// // //               </Link>
// // //             ))}

// // //             {/* Dropdown */}
// // //             <DropdownMenu>
// // //               <DropdownMenuTrigger className="flex items-center gap-1 text-gray-700 hover:text-[#C08B89] transition-colors">
// // //                 ORDER NOW
// // //                 <ChevronDown className="w-4 h-4" />
// // //               </DropdownMenuTrigger>
// // //               <DropdownMenuContent align="end">
// // //                 <DropdownMenuItem asChild>
// // //                   <Link to="/products">All Products</Link>
// // //                 </DropdownMenuItem>
// // //                 {categories.map((cat) => (
// // //                   <DropdownMenuItem key={cat.id} asChild>
// // //                     <Link to={`/products?categoryId=${cat.id}`}>{cat.name}</Link>
// // //                   </DropdownMenuItem>
// // //                 ))}
// // //               </DropdownMenuContent>
// // //             </DropdownMenu>
// // //           </nav>

// // //           {/* Right Section */}
// // //           <div className="flex items-center space-x-3 ml-auto md:ml-0">
// // //             {/* Search Box */}
// // //             <form onSubmit={handleSearch} className="hidden md:flex items-center space-x-2">
// // //               <div className="relative">
// // //                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
// // //                 <Input
// // //                   placeholder="Search products..."
// // //                   className="pl-10 w-56 lg:w-64"
// // //                   value={searchTerm}
// // //                   onChange={(e) => setSearchTerm(e.target.value)}
// // //                   style={{ fontFamily: "Manrope, sans-serif" }}
// // //                 />
// // //               </div>
// // //             </form>

// // //             {/* Notification */}
// // //             <NotificationBell />

// // //             {/* Mobile Menu */}
// // //             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
// // //               <SheetTrigger asChild>
// // //                 <Button variant="ghost" size="sm" className="md:hidden">
// // //                   <Menu className="w-6 h-6" />
// // //                 </Button>
// // //               </SheetTrigger>
// // //               <SheetContent side="right" className="w-72 sm:w-80" style={{ fontFamily: "Manrope, sans-serif" }}>
// // //                 <div className="flex flex-col space-y-5 mt-8">
// // //                   {[
// // //                     { path: "/", label: "HOME" },
// // //                     { path: "/about", label: "ABOUT US" },
// // //                     { path: "/products", label: "ORDER NOW" },
// // //                     { path: "/contact", label: "CONTACT US" },
// // //                     { path: "/blog", label: "BLOG" },
// // //                   ].map((link) => (
// // //                     <Link
// // //                       key={link.path}
// // //                       to={link.path}
// // //                       onClick={() => setIsMenuOpen(false)}
// // //                       className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
// // //                     >
// // //                       {link.label}
// // //                     </Link>
// // //                   ))}

// // //                   {/* Mobile Search */}
// // //                   <form onSubmit={handleSearch}>
// // //                     <Input
// // //                       placeholder="Search products..."
// // //                       className="mt-3"
// // //                       value={searchTerm}
// // //                       onChange={(e) => setSearchTerm(e.target.value)}
// // //                       style={{ fontFamily: "Manrope, sans-serif" }}
// // //                     />
// // //                   </form>
// // //                 </div>
// // //               </SheetContent>
// // //             </Sheet>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </header>
// // //   );
// // // };

// // // export default Header;

// // import React, { useState, useEffect } from "react";
// // import { Link, useLocation as useRouterLocation, useNavigate } from "react-router-dom";
// // import { Button } from "./ui/button";
// // import { Input } from "./ui/input";
// // import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
// // import { Search, Menu, MapPin, ChevronDown } from "lucide-react";
// // import { useLocation } from "../context/LocationContext";
// // import apiService from "../services/api";
// // import NotificationBell from "./NotificationBell";

// // const Header = () => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const location = useRouterLocation();
// //   const navigate = useNavigate();
// //   const { selectedLocation, locations, changeLocation } = useLocation();

// //   const isActive = (path) => location.pathname === path;

// //   const handleSearch = (e) => {
// //     e.preventDefault();
// //     if (searchTerm.trim()) {
// //       // navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
// //       setSearchTerm("");
// //     }
// //   };

// //   return (
// //     <header className="bg-white shadow-sm border-b w-full" style={{ fontFamily: "Manrope, sans-serif" }}>
// //       {/* Top Bar */}
// //       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600">
// //         <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
// //           <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2">
// //             <span>📞 Call / WhatsApp: +91 8121034991</span>
// //           </div>

// //           {/* Location Dropdown */}
// //           <div className="flex items-center justify-center sm:justify-start gap-1">
// //             <MapPin className="w-4 h-4" />
// //             {selectedLocation && (
// //               <div className="flex items-center gap-1 hover:text-gray-900 cursor-pointer" style={{ fontFamily: "Philosopher", serif" }}>
// //                 {selectedLocation.name}
// //                 <ChevronDown className="w-3 h-3" />
// //               </div>
// //             )}
// //           </div>

// //           <div className="flex justify-center sm:justify-end">
// //             <span>📧 hello@bakelore.com</span>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Main Header */}
// //       <div className="px-4 py-3 sm:py-4">
// //         <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">
// //           {/* Logo */}
// //           <Link to="/" className="flex items-center">
// //             <img
// //               src="http://bakelore.com/images/bakelore-logo"
// //               alt="Bakelore Logo"
// //               className="h-10 w-auto sm:h-12"
// //             />
// //           </Link>

// //           {/* Desktop Nav */}
// //           <nav className="hidden md:flex items-center space-x-8" style={{ fontFamily: "Philosopher", serif" }}>
// //             {[
// //               { path: "/", label: "Home" },
// //               { path: "/about", label: "About Us" },
// //               { path: "/blogs", label: "Blogs" },
// //               { path: "/contact", label: "Contact Us" },
// //             ].map((link) => (
// //               <Link
// //                 key={link.path}
// //                 to={link.path}
// //                 className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
// //                   isActive(link.path) ? "font-semibold text-[#C08B89]" : ""
// //                 }`}
// //               >
// //                 {link.label}
// //               </Link>
// //             ))}
// //           </nav>

// //           {/* Right Section */}
// //           <div className="flex items-center space-x-3 ml-auto md:ml-0">
// //             {/* Search Box */}
// //             <form onSubmit={handleSearch} className="hidden md:flex items-center space-x-2">
// //               <div className="relative">
// //                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
// //                 <Input
// //                   placeholder="Search products..."
// //                   className="pl-10 w-56 lg:w-64"
// //                   value={searchTerm}
// //                   onChange={(e) => setSearchTerm(e.target.value)}
// //                   style={{ fontFamily: "Manrope, sans-serif" }}
// //                 />
// //               </div>
// //             </form>

// //             {/* Notification */}
// //             <NotificationBell />

// //             {/* Mobile Menu */}
// //             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
// //               <SheetTrigger asChild>
// //                 <Button variant="ghost" size="sm" className="md:hidden">
// //                   <Menu className="w-6 h-6" />
// //                 </Button>
// //               </SheetTrigger>
// //               <SheetContent side="right" className="w-72 sm:w-80" style={{ fontFamily: "Manrope, sans-serif" }}>
// //                 <div className="flex flex-col space-y-5 mt-8">
// //                   {[
// //                     { path: "/", label: "HOME" },
// //                     { path: "/about", label: "ABOUT US" },
// //                     { path: "/products", label: "ORDER NOW" },
// //                     { path: "/contact", label: "CONTACT US" },
// //                   ].map((link) => (
// //                     <Link
// //                       key={link.path}
// //                       to={link.path}
// //                       onClick={() => setIsMenuOpen(false)}
// //                       className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
// //                     >
// //                       {link.label}
// //                     </Link>
// //                   ))}

// //                   {/* Mobile Search */}
// //                   <form onSubmit={handleSearch}>
// //                     <Input
// //                       placeholder="Search products..."
// //                       className="mt-3"
// //                       value={searchTerm}
// //                       onChange={(e) => setSearchTerm(e.target.value)}
// //                       style={{ fontFamily: "Manrope, sans-serif" }}
// //                     />
// //                   </form>
// //                 </div>
// //               </SheetContent>
// //             </Sheet>
// //           </div>
// //         </div>
// //       </div>
// //     </header>
// //   );
// // };

// // export default Header;

// import React, { useState } from "react";
// import {
//   Link,
//   useLocation as useRouterLocation,
//   useNavigate,
// } from "react-router-dom";
// import { Button } from "./ui/button";
// import { Input } from "./ui/input";
// import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
// import { Search, Menu, MapPin, ChevronDown, X } from "lucide-react";
// import { useLocation } from "../context/LocationContext";
// import NotificationBell from "./NotificationBell";

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const location = useRouterLocation();
//   const navigate = useNavigate();
//   const { selectedLocation } = useLocation();

//   const isActive = (path) => location.pathname === path;

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (searchTerm.trim()) {
//       navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
//       setSearchTerm("");
//       setIsMenuOpen(false); // close mobile menu if open
//     }
//   };

//   const desktopLinks = [
//     { path: "/", label: "Home" },
//     { path: "/about", label: "About Us" },
//     { path: "/blogs", label: "Blogs" },
//     { path: "/contact", label: "Contact Us" },
//   ];

//   const mobileLinks = [
//     { path: "/", label: "Home" },
//     { path: "/about", label: "About Us" },
//     { path: "/blogs", label: "Blogs" },
//     { path: "/products", label: "Order Now" },
//     { path: "/contact", label: "Contact Us" },
//   ];

//   return (
//     <header
//       className="bg-white shadow-sm border-b w-full"
//       style={{ fontFamily: "Manrope, sans-serif" }}
//     >
//       {/* Top Bar */}
//       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600">
//         <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
//           <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2">
//             <span>📞 Call / WhatsApp: +91 8121034991</span>
//           </div>

//           <div className="flex items-center justify-center sm:justify-start gap-1">
//             <MapPin className="w-4 h-4" />
//             {selectedLocation && (
//               <div
//                 className="flex items-center gap-1 hover:text-gray-900 cursor-pointer"
//                 style={{ fontFamily: "Philosopher", serif" }}
//               >
//                 {selectedLocation.name}
//                 <ChevronDown className="w-3 h-3" />
//               </div>
//             )}
//           </div>

//           <div className="flex justify-center sm:justify-end">
//             <span>📧 hello@bakelore.com</span>
//           </div>
//         </div>
//       </div>

//       {/* Main Header */}
//       <div className="px-4 py-3 sm:py-4">
//         <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">
//           {/* Logo */}
//           <Link to="/" className="flex items-center">
//             <img
//               src="http://bakelore.com/images/bakelore-logo"
//               alt="Bakelore Logo"
//               className="h-10 w-auto sm:h-12"
//             />
//           </Link>

//           {/* Desktop Nav */}
//           <nav
//             className="hidden md:flex items-center space-x-8"
//             style={{ fontFamily: "Philosopher", serif" }}
//           >
//             {desktopLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
//                   isActive(link.path) ? "font-semibold text-[#C08B89]" : ""
//                 }`}
//               >
//                 {link.label}
//               </Link>
//             ))}
//           </nav>

//           {/* Right Section */}
//           <div className="flex items-center space-x-3 ml-auto md:ml-0">
//             {/* Search Box */}
//             <form
//               onSubmit={handleSearch}
//               className="hidden md:flex items-center space-x-2"
//             >
//               <div className="relative">
//                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
//                 <Input
//                   placeholder="Search products..."
//                   className="pl-10 w-56 lg:w-64"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   style={{ fontFamily: "Manrope, sans-serif" }}
//                 />
//               </div>
//             </form>

//             {/* Order Now Button (Desktop Only) */}
//             <Button
//               variant="default"
//               size="sm"
//               className="hidden md:inline-flex bg-[#C08B89] text-white hover:bg-[#a77270]"
//               onClick={() =>
//                 window.open(
//                   "https://api.whatsapp.com/send/?phone=917997000828&text=View+Menu%21&type=phone_number&app_absent=0",
//                   "_blank"
//                 )
//               }
//             >
//               ORDER NOW
//             </Button>

//             {/* Notification */}
//             <NotificationBell />

//             {/* Mobile Menu */}
//             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
//               <SheetTrigger asChild>
//                 <Button variant="ghost" size="sm" className="md:hidden">
//                   <Menu className="w-6 h-6" />
//                 </Button>
//               </SheetTrigger>
//               <SheetContent
//                 side="right"
//                 className="w-72 sm:w-80"
//                 style={{ fontFamily: "Manrope, sans-serif" }}
//               >
//                 <div className="flex flex-col space-y-5 mt-8">
//                   {mobileLinks.map((link) => (
//                     <Link
//                       key={link.path}
//                       to={link.path}
//                       onClick={() => setIsMenuOpen(false)}
//                       className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
//                     >
//                       {link.label}
//                     </Link>
//                   ))}

//                   {/* Mobile Search */}
//                   <form onSubmit={handleSearch}>
//                     <Input
//                       placeholder="Search products..."
//                       className="mt-3"
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       style={{ fontFamily: "Manrope, sans-serif" }}
//                     />
//                   </form>
//                 </div>
//               </SheetContent>
//             </Sheet>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;



import React, { useState } from "react";
import {
  Link,
  useLocation as useRouterLocation,
  useNavigate,
} from "react-router-dom";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Search, Menu, MapPin, ChevronDown } from "lucide-react";
import { useLocation } from "../context/LocationContext";
import NotificationBell from "./NotificationBell";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useRouterLocation();
  const navigate = useNavigate();
  const { selectedLocation } = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm("");
      setIsMenuOpen(false);
    }
  };

  const desktopLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Us" },
    { path: "/blogs", label: "Blogs" },
    { path: "/contact", label: "Contact Us" },
  ];

  const mobileLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Us" },
    { path: "/blogs", label: "Blogs" },
    { path: "#", label: "Order Now" },
    { path: "/contact", label: "Contact Us" },
  ];

  return (
    <header
      className="bg-white shadow-sm border-b w-full"
      style={{ fontFamily: "Manrope, sans-serif" }}
    >
      {/* ================= TOP BAR ================= */}
      <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600">
        <div className="max-w-7xl mx-auto flex items-center justify-between">

          {/* 📞 Mobile Number (VISIBLE ON MOBILE & DESKTOP) */}
          <div className="flex items-center justify-center w-full sm:w-auto">
            <a
              href="tel:+918121034991"
              className="font-medium"
            >
              📞 Call / WhatsApp: +91 8121034991
            </a>
          </div>

          {/* 📍 Location (DESKTOP ONLY) */}
          {/* <div className="hidden sm:flex items-center gap-1">
            <MapPin className="w-4 h-4" />
            {selectedLocation && (
              <div
                className="flex items-center gap-1 hover:text-gray-900 cursor-pointer"
                style={{ fontFamily: "Philosopher", serif" }}
              >
                {selectedLocation.name}
                <ChevronDown className="w-3 h-3" />
              </div>
            )}
          </div> */}

          {/* 📧 Email (DESKTOP ONLY) */}
          <div className="hidden sm:flex">
            <span>📧 hello@bakelore.com</span>
          </div>

        </div>
      </div>

      {/* ================= MAIN HEADER ================= */}
      <div className="px-4 py-3 sm:py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">

          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="http://bakelore.com/images/bakelore-logo"
              alt="Bakelore Logo"
              className="h-10 w-auto sm:h-12"
            />
          </Link>

          {/* Desktop Nav */}
          <nav
            className="hidden md:flex items-center space-x-8"
            style={{ fontFamily: "Philosopher, serif" }}
          >
            {desktopLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-gray-700 hover:text-[#C08B89] transition-colors ${
                  isActive(link.path)
                    ? "font-semibold text-[#C08B89]"
                    : ""
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right Section */}
          <div className="flex items-center space-x-3 ml-auto md:ml-0">

            {/* Search (Desktop Only) */}
            <form
              onSubmit={handleSearch}
              className="hidden md:flex items-center space-x-2"
            >
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input
                  placeholder="Search products..."
                  className="pl-10 w-56 lg:w-64"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </form>

            {/* Order Now (Desktop Only) */}
            <Button
              size="sm"
              className="hidden md:inline-flex bg-[#C08B89] text-white hover:bg-[#a77270]"
              onClick={() =>
                window.open(
                  "#",
                  "_blank"
                )
              }
            >
              ORDER NOW
            </Button>

            {/* Notification */}
            <NotificationBell />

            {/* Mobile Menu */}
            <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm" className="md:hidden">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>

              <SheetContent side="right" className="w-72 sm:w-80">
                <div className="flex flex-col space-y-5 mt-8">

                  {mobileLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => setIsMenuOpen(false)}
                      className="text-lg font-medium text-gray-700 hover:text-[#C08B89]"
                    >
                      {link.label}
                    </Link>
                  ))}

                  {/* Mobile Search */}
                  <form onSubmit={handleSearch}>
                    <Input
                      placeholder="Search products..."
                      className="mt-3"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </form>

                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
